/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Showcase_Title_TailInputs */

const en_features_showcase_title_tail = /** @type {(inputs: Features_Showcase_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app handles the rest.`)
};

const pl_features_showcase_title_tail = /** @type {(inputs: Features_Showcase_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resztę ogarnia aplikacja.`)
};

/**
* | output |
* | --- |
* | "The app handles the rest." |
*
* @param {Features_Showcase_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_showcase_title_tail = /** @type {((inputs?: Features_Showcase_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Showcase_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_showcase_title_tail(inputs)
	return en_features_showcase_title_tail(inputs)
});